import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'App Error',
    entityNamePlural: 'App Errors',
    entityNameModule: 'admin',
  }), [])
}
